import React, { useEffect, useRef, useState } from "react";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { getAllBlogAsync, DubaiBlogActions } from "../redux";
import BlogTable from "./blogDetail/blogTable";
import {
  Card,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import { DubaiblogStatus } from "../constants/constants";
import { useIsAccessAllow } from "../../users/redux";

const statusOptionList = [
  { status: "Draft", value: DubaiblogStatus.DRAFT },
  { status: "Published", value: DubaiblogStatus.PUBLISHED },
  { status: "Pending Review", value: DubaiblogStatus.PENDING_REVIEW },
  { status: "Future", value: DubaiblogStatus.FUTURE },
  { status: "Auto Draft", value: DubaiblogStatus.AUTO_DRAFT },
];

export function DubaiBlog() {
  const dispatch = useDispatch();
  const history = useHistory();
  const searchRef = useRef();
  const { refreshBlog, searchBy, searchText, status } = useSelector(
    (state) => state.blog,
    shallowEqual
  );

  useEffect(() => {
    if (searchRef.current) {
      let keyPressEvent = (e) => {
        if (e.keyCode === 13) {
          e.preventDefault();
          dispatch(DubaiBlogActions.refreshBlogList());
        }
      };
      let input = searchRef.current;
      input.addEventListener("keyup", keyPressEvent);

      return () => {
        input.removeEventListener("keyup", keyPressEvent);
        dispatch(DubaiBlogActions.searchTextChange(""));
        input.value = "";
      };
    }
  }, [dispatch]);

  useEffect(() => {
    if (refreshBlog) {
      dispatch(getAllBlogAsync(searchBy, searchText, status));
    }
    // eslint-disable-next-line
  }, [refreshBlog]);

  const onSearchTextChange = (e) => {
    dispatch(DubaiBlogActions.searchTextChange(e.target.value));
  };

  const onChangeStatus = (e) => {
    dispatch(DubaiBlogActions.searchChangeStatus(e.target.value));
    dispatch(DubaiBlogActions.refreshBlogList());
  };

  const onSelectBlog = (blog) => {
    history.push(`/dubai_blog/add-blog`);
  };
  const isAddBlogAllow = useIsAccessAllow("dubai_blog.add_blog");
  const isListAllow = useIsAccessAllow("dubai_blog.list");

  return (
    <>
      <Card>
        <CardHeader title="Dubai Blog">
          <CardHeaderToolbar>
            <div className="d-flex flex-wrap ap_filter_wraper justify-content-end align-items-center">
              <form
                className="subheader_filter"
                onSubmit={(e) => e.preventDefault()}
              >
                <div className="form-row">
                  {isAddBlogAllow && (
                    <div className="form-group mr-5 mb-1 mt-2">
                      <button
                        className="btn_new btn-sm"
                        type="button"
                        onClick={() => onSelectBlog()}
                      >
                        Add
                      </button>
                    </div>
                  )}
                  {isListAllow && (
                    <div className="form-group mr-3 mb-1">
                      <input
                        name="Search"
                        placeholder="Search. . ."
                        type="text"
                        className="form-control"
                        value={searchText}
                        autoComplete="off"
                        onChange={onSearchTextChange}
                        ref={searchRef}
                      />
                    </div>
                  )}
                  {isListAllow && (
                    <div className="form-group mr-3 mb-1">
                      <select
                        className="form-control"
                        value={status || ""}
                        onChange={onChangeStatus}
                      >
                        <option value="">All Status</option>
                        {statusOptionList?.map((statusdata) => (
                          <option key={statusdata.value} value={statusdata.value}>
                            {statusdata.status}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </CardHeaderToolbar>
        </CardHeader>
        <BlogTable />
      </Card>
    </>
  );
}
